import Notification, { DEFAULT_SELECTOR } from 'CoreComponents/notification';

document.querySelectorAll(DEFAULT_SELECTOR).forEach(notification => {
  new Notification(notification);
});
